<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>User Details</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">User Details</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="overlay" v-if="is_loading">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>

              <div class="card-tools d-felx row">
                <b-button v-b-modal.update-user-status-modal class="btn btn-success">
                  Review
                </b-button>
              </div>

              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'EWUserPendingDetailList'}">
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="custom-list">
                <ul>

                  <li><strong>ID</strong> {{ value.id }}</li>

                  <li><strong>User ID</strong> {{ value.user_id }}</li>
                  <li><strong>UserName</strong> {{ !_.isEmpty(value.userinfo) ? value.userinfo.name : 'NA' }}</li>

                  <li>
                    <strong>Gender</strong>
                    {{
                      !_.isEmpty(value.gender) ? value.gender.charAt(0).toUpperCase() + value.gender.slice(1) : 'NA'
                    }}
                  </li>

                  <li><strong>Date of Birth</strong> {{ !_.isEmpty(value.date_of_birth) ? value.date_of_birth : 'NA' }}
                  </li>

                  <li><strong>NID Number</strong> {{ !_.isEmpty(value.nid_number) ? value.nid_number : 'NA' }}</li>

                  <li><strong>NID Front Image</strong>
                    <img v-if="!_.isEmpty(value.id_card_image)" v-bind:src="API_ASSET_UPLOAD_URL+value.id_card_image" class="img-fluid img-thumbnail rounded"
                         style="width: 200px;">
                    <span v-else>Not Available</span>
                  </li>

                  <li><strong>NID Back Image</strong>
                    <img v-if="!_.isEmpty(value.selfie_image)" v-bind:src="API_ASSET_UPLOAD_URL+value.selfie_image" class="img-fluid img-thumbnail rounded"
                         style="width: 200px;">
                    <span v-else>Not Available</span>
                  </li>

                  <li><strong>Status</strong>
                    {{
                      !_.isEmpty(value.status) ? value.status.charAt(0).toUpperCase() + value.status.slice(1) : 'Pending'
                    }}
                  </li>
                  <li><strong>Step</strong> {{ value.step }}</li>
                  <li><strong>Comment</strong> {{ value.comment }}</li>

                  <li><strong>Country</strong>
                    <span v-if="!_.isNil(value.country_id)">{{ pre.country_id[value.country_id] }}</span>
                  </li>

                  <li><strong>City</strong>
                    <span v-if="!_.isNil(value.city_id)">{{ pre.city_id[value.city_id] }}</span>
                  </li>

                  <li><strong>CreateTime </strong> {{ customFormatter(value.created_at, 'lll') }}</li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>

    <b-modal
      id="update-user-status-modal" ref="update-user-status-modal" title="Review"
      @show="resetModal" @hidden="resetModal" @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <label>Status</label>

        <b-form-group>
          <b-form-select
            label="Status"
            class="form-control mr-3"
            style="width: 100px;"
            v-bind:class="{ 'has-error': errors.has('status') }"
            v-validate="'required'" name="status"
            v-model="value.status" id="status"
            :state="status_state"
          >
            <option value="">Select - Any</option>
            <option value="approved">Approved</option>
            <option value="pending">Pending</option>
            <option value="hold">Hold</option>
            <option value="rejected">Rejected</option>
          </b-form-select>
        </b-form-group>

        <b-form-group
          label="Comment"
          label-for="name-input"
          :state="comment_state"
        >
          <b-form-input
            id="comment-input"
            v-model="value.comment"
            type="text"
            :state="comment_state"
          />
        </b-form-group>


      </form>
    </b-modal>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import {DepartmentsAPI} from '@/services/api'
import axios from 'axios'
import {Notification} from 'element-ui'

const fileDownload = require("js-file-download")


export default {
  name: 'EWUserPendingDetailShow',
  metaInfo: {
    title: 'User Pending Details | Dotlines'
  },
  data: () => ({
    value: {},
    pre: {
      country_id: [], city_id: [],
    },
    is_loading: false
  }),
  mounted: function () {
    this.initialize()
  },
  methods: {
    customFormatter(date, format = 'MMM Do YY, h:mm:ss a') {
      return moment(date).format(format);
    },
    handleSubmit() {
      this.$refs['update-user-status-modal'].show()

      if (!this.checkFormValidity()) {
        return
      }
      // Push the name to submitted names

      this.is_loading = true
      let api_url = '/ew_user_details/' + this.$route.params.id

      axios({
        method: 'PUT',
        url: api_url,
        data: {
          comment: this.value.comment,
          status: this.value.status,
          user_id: this.value.user_id
        },
        headers: {'Content-Type': 'application/json'},
      }).then(function (response) {
        this.$toaster.success(response.data.message)
        // this.$router.push({ 'name': 'EWUserDetailList' })
      }).catch((errors) => {
        if (errors.response.status === 500) {
          this.$toaster.error(errors.response.data.message)
        }
        this.$setErrorsFromResponse(errors.response.data)
      }).finally(() => {
        this.is_loading = false
      });

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('update-user-status-modal')
      })
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.comment_state = valid
      return valid
    },

    countryIdOptions: function () {
      return new Promise(resolve => {
        axios.get("/get-dropdown-options/3")
          .then(response => {
            resolve(response.data)
          })
          .catch((error) => {
            console.log('error ' + error)
            resolve(error)
          })
      })
    },
    cityIdOptions: function () {
      return new Promise(resolve => {
        axios.get("/get-dropdown-options/2")
          .then(response => {
            resolve(response.data)
          })
          .catch((error) => {
            console.log('error ' + error)
            resolve(error)
          })
      })
    },

    async initialize() {
      this.is_loading = true
      this.params = this.$route.params

      await this.countryIdOptions().then(country_id => {
        this.pre.country_id = country_id
      })
      await this.cityIdOptions().then(city_id => {
        this.pre.city_id = city_id
      })


      await this.getDetail(this.params.id).then(response => {
        this.value = response.data
      });

      this.is_loading = false
    },
    downloadFile: function (url) {
      this.is_loading = true
      axios.get(this.API_ASSET_UPLOAD_URL + url, {responseType: "arraybuffer"})
        .then(response => {
          fileDownload(response.data, url.replaceAll("/", "-"))
          Notification.success({
            title: 'Download Completed',
            message: 'Download completed successfully',
            type: 'success'
          })
        })
        .catch(error => {
          Notification.error({title: 'Download Failed', message: 'Failed to download', type: 'error'})
        })
        .finally(() => {
          this.is_loading = false
        });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line camelcase
        const api_url = '/ew_user_pending_details/' + id;
        axios.get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch((error) => {
            console.log('error ' + error)
            reject(error)
          })
          .finally(() => {
          });
      })
    },
    resetModal() {
      this.comment = ''
      this.comment_state = null
    },
    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault()

      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const _this = this

      _this.$swal.fire({
        title: 'Are you sure?',
        text: "You want to perform this action!",
        confirmButtonText: 'Yes, do it!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      }).then((result) => {
        if (result.isConfirmed) {
          // Trigger submit handler
          this.handleSubmit()
        }
      })

    },
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
}
</script>
